function stringToColor(string) {
    let hash = 0;
    let i;
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
}
  
function getInitials(name, email = '') {
  // Try username first
  if (typeof name === 'string' && name.trim().length > 0) {
    const trimmedName = name.trim();
    const firstInitial = trimmedName.charAt(0).toUpperCase();
    const spaceIndex = trimmedName.indexOf(" ");
    const lastInitial = (spaceIndex !== -1 && trimmedName.length > spaceIndex + 1) 
        ? trimmedName.charAt(spaceIndex + 1).toUpperCase() 
        : "";
    return firstInitial + lastInitial;
  }

  // Try email fallback
  if (typeof email === 'string' && email.trim().length > 0) {
    return email.charAt(0).toUpperCase();
  }

  // Generic fallback
  return 'U';
}

export function stringAvatar(name = '', email = '') { 
  if (typeof name !== 'string') {
      name = '';
  }
  
  // Use name for color generation, but fall back to email if name is empty
  const colorSource = (name && name.trim()) ? name : (email || 'User');
  
  return {
      sx: {
          bgcolor: stringToColor(colorSource),
      },
      children: getInitials(name, email),
  };
}